import { useState } from "react";
import { Box, Typography, TextField, Button, Grid, Alert } from "@mui/material";
import { defaultStyle } from "components/Modals";
import { updateBatteryGroup } from "api/resources/batteryGroups";
import { FormErrorProps } from "api/models/FormErrorProps";

type EditBatteryGroupModalProps = {
  group: { id: number; name: string; externalId?: string };
  dispatch: any;
  setEditModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const EditBatteryGroupModal = ({
  group,
  dispatch,
  setEditModal,
}: EditBatteryGroupModalProps) => {
  const [formErrors, setFormErrors] = useState(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const postData = {
      name: data.get("name"),
      externalId: data.get("externalId"),
    };

    updateBatteryGroup(group.id, postData)
      .then(() => {
        setEditModal(false);
        dispatch();
      })
      .catch((error) => {
        setFormErrors(error.response.data.errors);
      });
  };

  return (
    <Box sx={defaultStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h5">
        Edit battery group
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2} sx={{ mt: "1rem", mb: "2rem" }}>
          <Grid item sm={12}>
            <TextField
              id="name"
              name="name"
              label="Name"
              size="small"
              required
              defaultValue={group.name}
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item sm={12}>
            <TextField
              id="externalId"
              name="externalId"
              label="External ID"
              size="small"
              defaultValue={group.externalId || ""}
              sx={{ width: "100%" }}
            />
          </Grid>
          {formErrors && (
            <Grid item sm={12}>
              {formErrors.map(({ message }: FormErrorProps) => (
                <Alert variant="filled" severity="error" sx={{ mb: "0.4rem" }}>
                  {message}
                </Alert>
              ))}
            </Grid>
          )}
          <Grid item sm={12} sx={{ mt: "1rem" }}>
            <Button variant="contained" type="submit" sx={{ mr: "1rem" }}>
              Save
            </Button>
            <Button onClick={() => setEditModal(false)}>Cancel</Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default EditBatteryGroupModal;
